/* /game-plan/tv — kiosk route for office TVs. Runs unattended with its own data loop,
   wake lock, auto-reconnect and celebration alerts. */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CelebrationProvider } from '../components/gameplan/jarvis/Celebrations';
import PerformanceTV from '../components/gameplan/jarvis/PerformanceTV';

export default function GamePlanTV() {
  const { token } = useAuth();
  const navigate = useNavigate();
  return (
    <CelebrationProvider token={token}>
      <PerformanceTV token={token} kiosk onExit={() => navigate('/game-plan')} />
    </CelebrationProvider>
  );
}
